import React from 'react';
import {style, classes} from './doppe-viewer-modal-panel-section.st.css';
import { reactCreateMemo } from "@wix/devzai-utils-react";

export const DoppeViewerModalPanelSection = reactCreateMemo(function DoppeViewerModalPanelSection (props: DoppeViewerModalPanelSection.Props) {
    const {
        className,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        />
    );
});

export namespace DoppeViewerModalPanelSection {

    export interface Props extends React.HTMLAttributes<any> {

    }
}
